/**
 * useApproveLeave — React Query mutation szabadság jóváhagyásához
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { approveLeave, type LeaveRequest } from '../api/hr-api';
import { leaveCalendarQueryKey } from './useLeaveCalendar';
import { leaveRequestsQueryKey } from './useLeaveRequests';

export function useApproveLeave() {
  const queryClient = useQueryClient();

  return useMutation<LeaveRequest, Error, string>({
    mutationFn: async (id: string) => {
      const res = await approveLeave(id);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leaveRequestsQueryKey });
      const now = new Date();
      void queryClient.invalidateQueries({
        queryKey: leaveCalendarQueryKey(now.getFullYear(), now.getMonth() + 1),
      });
    },
  });
}
